import React, { useRef, useEffect, useState } from 'react'
import { Pane, CaretLeftIcon, CaretRightIcon, Button, Heading, TextInput, Text } from 'evergreen-ui'

import { Drawing, TYPE_FOLD, TYPE_CUT, TYPE_IGNORE, DrawingDlg } from '../Drawing';
import { Size, Details } from "../Drawing";

import { SelectMaterials } from './Materials';
import { Services } from './Services';
import { SubTotal } from './SubTotal';
import { useAPI } from '../Api';
import { useCart } from '../Cart';
import { PageControl, DropZone } from '../Misc';

import { findMaterial } from './Materials/MaterialFuncs'


import debugModule from 'debug';
const debug = console.log

import './quote.scss';

export function DrawingTab(props) {
  // console.log('DrawingTab',props.ids)
  return <Pane display="flex" width="100%" elevation={3}>
    <Pane className='col'
      display="flex"
      backgroundColor="white"
      justifyContent="center"
      alignItems="center"
      borderRight="2px grey dashed"
      padding={30}
    >
      <DrawingDlg heading={props.order.book.display} drawing={props.order.drawing} ids={props.ids} setIds={props.setIds} Width={400} Height={400} />
    </Pane>
    <Pane
      className='col'
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexGrow="3"
      backgroundColor="white"
    >
      {props.children}
    </Pane>
  </Pane>
}

function PageReview(props) {
  let API = useAPI();
  // console.log("In Page Review: " , props)
  return <Pane elevation={1}
    backgroundColor="#F3F6FF"
    display="flex"
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
    flexGrow="1"
  >
    <DrawingTab {...props} style={{ flexDirection: 'row' }}>
      <div style={{ flexDirection: 'column', width: "80%" }}>
        <Text>
          <h4 style={{ textAlign: 'center' }}>Max Area: <Size drawing={props.order.drawing} /></h4>
        </Text>

        {API.isAdmin &&
                    <Pane  marginTop={'2em'} display="flex" justifyContent="center">
                        <Pane border={"1px solid red"} borderRadius={"10px"} padding={"10px"} height={"fit-content"}>
                            <Text>Cutting Length: {props.order.cuttingLength?.toFixed(2)} mm</Text>
                        </Pane>
                    </Pane>
                }

        <Details drawing={props.order.drawing} ids={props.ids} setIds={props.setIds} onActionsChange={props.onActionsChange}/>
      </div>
    </DrawingTab>
  </Pane>

}

function PageMaterial(props) {
  return <Pane elevation={0}
    backgroundColor="#F3F6FF"
    display="flex"
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
    flexGrow="1"

  ><DrawingTab {...props}>
      {props.order && <SelectMaterials {...props}></SelectMaterials>}
    </DrawingTab>
  </Pane>
}

function SelectServices(props) {


  //set bends array if they are not there
  // if (!props.order.bends)
  //   props.order.bends = props.drawing.lines.filter((v) => v.Type == 'BEND').map((v) => { return { id: v.id, value: null } })
  return <Pane elevation={0}
    background="blueTint"
    display="flex"
    justifyContent="center"
    alignItems="center"
    flexDirection="column"
    flexGrow="1"

  >
    <DrawingTab {...props}>

      <Services  {...props} />
      <SubTotal flexGrow="1"
        {...props}
      />

    </DrawingTab>
  </Pane>
}

function Footer(props) {
  // /className="stickyFooter"
  return <Pane height={64} className={"stickyFooter"}  display="flex" padding={16} background="tint2" borderRadius={3} justifyContent={"space-between"}>
    <Button onClick={() => { props.onClose() }} appearance="primary"><CaretLeftIcon /> <strong>Close</strong></Button>

    {/* <Heading size={600}>{props.heading} </Heading> */}

    <Pane>
      {props.children}
    </Pane>
  </Pane>
}


function PageHeader(props) {
  return <Pane height={32} padding={8} background="tint2" borderRadius={3} justifyContent={"center"}>
    <Heading size={600}>{props.heading} </Heading>
  </Pane>
}

export function Quote(props) {
  document.title = 'DuraProducts - New Quote'


  const [page, setPage] = React.useState(props.order.book.dxf ? (props.order.selMaterial ? 4 : 2) : 1);

  const [ids, setIds] = React.useState([]);

  const [disabled, setDisabled] = useState(true);
  const [update, setUpdate] = useState(false);

  const API = useAPI();
  const Cart = useCart();



  const [Materials, setMaterials] = React.useState(null);
  const [material, setMaterial] = React.useState(props.order && props.order.selMaterial);

  // const [bends, setBends] = useState(null);

  let reFreshMatList = () => {

    Cart.remove(props.order.key); 
    setUpdate(true);
    API.getAllMaterials(props.order).then((m) => {
      if (m)
        setMaterials([...m])
      setUpdate(false)
    });
  }


  let reFreshMaterial = () => {
    setUpdate(true)
    API.getMaterial(props.order).then((m) => {
      // console.log(">>>>>',m",m)
      if (m)
       { setMaterial(findMaterial(m.Materials, material));
        let o = props.order;
        o.RawSetupFee = m.SetupFee;
        props.setOrder({ ...o });
      
      }
      setUpdate(false)
    });
  }


  useEffect(() => {
    debug('Page', page)

    switch (page) {
      case 3: reFreshMatList(); break;
      case 4: reFreshMaterial(); break;
    }

  }, [page]);




  useEffect(() => {
    reFreshMaterial()
  }, [props.order.qty]);

  useEffect(() => {
    let o = props.order;
    o.selMaterial = material;
    props.setOrder({ ...o });
    setDisabled(material == null);
  }, [material])



  let Headings = [
    "", "Select file for uploading", "Confirm Size and Preview", "Please select the material", "Select Service"
  ]

  const updateBends = () => {
    props.order.bends = []
    props.order.bends = props.order.drawing.updateBends();
    props.setOrder({ ...props.order });
    setIds([]);
    // console.log("Bends Updated: ", props.order.drawing.bends)
  }

  const bendsChanged = () => {
    props.order.drawing.bends = props.order.bends
    props.setOrder({ ...props.order });
    // console.log("Bends bendsChanged: ", props.order.bends)
  }

  const updateDrawingInfo = (totals) => {
    if (totals && totals.Cuts) {
      // console.log("Updating Cuts...");
      let o = props.order;
      o.cuts = totals.Cuts.qty;
      o.cuttingLength = totals.Cuts.totallen;
      props.setOrder({ ...o });
    }
  }

  // Chatra('updateIntegrationData',{
  //   'last DXF File': props.order.book.display
  // });
  // console.log("Props.Order: ", props.order)

  return (<Pane className='quoteSection' display="flex" flexDirection="column" position="relative" overflow={"auto"}>
    <PageHeader heading={Headings[page]} />
    <PageControl page={page - 2} >
      <PageReview order={props.order} setPage={setPage} ids={ids} setIds={setIds} onActionsChange={updateDrawingInfo}/>
      <PageMaterial order={props.order} setOrder={props.setOrder} drawing={props.order.drawing} setPage={setPage} ids={ids}
        Materials={Materials} material={material} setMaterial={setMaterial} />
      <SelectServices
        updateBends={bendsChanged}

        drawing={props.order.drawing}
        setPage={setPage}
        ids={ids}
        setIds={setIds}
        order={props.order}
        setOrder={props.setOrder}
      />
    </PageControl>

    <Footer className="Footer" onClose={props.onClose}>
      <PageControl page={page - 2}  >
        <span>
          <Button marginRight={16} onClick={() => props.onClose()} ><strong>Cancel</strong></Button>
          <Button appearance="primary" onClick={() => { setPage(3); updateBends(); }}><strong>Accept</strong> <CaretRightIcon /> </Button>
        </span>

        <span>
          <Button marginRight={16} onClick={() => { setPage(page - 1) }}><strong>Back</strong></Button>
          <Button disabled={disabled} appearance="primary" onClick={() => { setPage(4) }}><strong>Next</strong> <CaretRightIcon /> </Button>
        </span>

        <span>
          <Button marginRight={16} onClick={() => { setPage(page - 1) }}><strong>Back</strong></Button>
          <Button
            disabled={update}
            appearance="primary"
            onClick={() => {
              // console.log("From Quote: ", props.order);
              props.onClose(true);
              Cart.add(props.order);
              props.order.isNew = false;
              props.order.bulkOrderWarning = false;
              // console.log("Done")
            }}>
            <strong>{props.order.isNew ? "Add to Cart" : "Update Cart"}</strong> <CaretRightIcon />
          </Button>
        </span>

      </PageControl>
    </Footer>
  </Pane >)

}